import CXMApiClient from "../../CXMApiClient";

const state = {};

const getters = {};

const actions = {
  // Used by Rule Group Management page to search and filter
  searchRuleGroups(context, requestPayload) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest("POST", "/api/RuleGroup/search", requestPayload)
        .then(resp => {
          resolve(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  saveRuleGroup(context, requestPayload) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest("POST", "/api/RuleGroup", requestPayload)
        .then(resp => {
          if (resp.data && resp.data.data) resolve(resp.data.data);
          else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  deleteRuleGroup(context, ruleGroupId) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest("DELETE", `/api/RuleGroup/${ruleGroupId}`)
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp);
          else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  async getWishlistGroupsForStore(context, platformId) {
    let cxmApiClient = new CXMApiClient();
    return await cxmApiClient
      .ProcessRequest(
        "GET",
        `/api/wishlist/wishlist_groups/platform/${platformId}`
      )
      .catch(err => err.response);
  },
  async getRuleGroupDetails(context, groupId) {
    let cxmApiClient = new CXMApiClient();
    let response = await cxmApiClient
      .ProcessRequest("GET", `/api/ruleGroup/${groupId}`)
      .catch(err => err.response);
    return response && response.data ? response.data : null;
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/rules/RuleGroups.js